export const adaptLists = (data) => (data || []).reduce((acc, item) => {
    const { listItems, listKey } = item;

    return ({
        ...acc,
        [listKey]: listItems.map((listItem) => ({ ...listItem, value: listItem?.id.toString(), label: listItem?.label })),
    });
}, {});
